import { ApolloLink } from '@apollo/client';
import { setContext } from '@apollo/client/link/context';

type GetAccessTokenFetcher = () => Promise<string | null>;

export function setAccessTokenLink(
  getAccessToken: GetAccessTokenFetcher
): ApolloLink {
  return setContext(async (_, { headers }) => {
    const token = await getAccessToken();
    return {
      headers: {
        ...headers,
        authorization: token ? `Bearer ${token}` : ''
      }
    };
  });
}
